import "./Management.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FullServiceAdministration from "./sections/FullServiceAdministration";
import EstimateYourRentalYield from "./sections/EstimateYourRentalYield";
import BookYourExperience from "./sections/BookYourExperience";
import FooterLegal from "@/reusable_sections/Footer";
export default function ManagementPage() {
  return <div>
      <MainNavigation />
      <FullServiceAdministration />
      <BookYourExperience />
      <EstimateYourRentalYield />
      <FooterLegal />
    </div>;
}